import PropTypes from 'prop-types';
import { useLanguage } from '../../context/LanguageContext.js';
import styles from './LoadingSpinner.module.css';

const LoadingSpinner = ({ message }) => {
  const { t } = useLanguage();
  const resolvedMessage = message ?? t('loadingSpinner.default');

  return (
    <div className={styles.container}>
      <div className={styles.spinner}></div>
      <p className={styles.message}>{resolvedMessage}</p>
    </div>
  );
};

LoadingSpinner.propTypes = {
  message: PropTypes.string,
};

export default LoadingSpinner;
